var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSharedUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 101,
    viewBox: "0 0 128 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_1441_172268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M88.0155 41.9385C93.6918 41.9385 98.2934 37.3317 98.2934 31.6489C98.2934 25.9662 93.6918 21.3594 88.0155 21.3594C82.3391 21.3594 77.7375 25.9662 77.7375 31.6489C77.7375 37.3317 82.3391 41.9385 88.0155 41.9385Z",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M88.0155 79.6484C93.6918 79.6484 98.2934 75.0416 98.2934 69.3589C98.2934 63.6761 93.6918 59.0693 88.0155 59.0693C82.3391 59.0693 77.7375 63.6761 77.7375 69.3589C77.7375 75.0416 82.3391 79.6484 88.0155 79.6484Z",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M64.3499 44.7946L79.0204 36.6455",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M78.3284 63.9731L63.7667 55.8862",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M47.0282 67.8411C56.5947 67.8411 64.3499 60.0772 64.3499 50.4999C64.3499 40.9226 56.5947 33.1587 47.0282 33.1587C37.4617 33.1587 29.7065 40.9226 29.7065 50.4999C29.7065 60.0772 37.4617 67.8411 47.0282 67.8411Z",
    stroke: "#4230E5",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M115.11 2.4458H12.8902C6.84454 2.4458 1.9436 7.35227 1.9436 13.4047V87.5952C1.9436 93.6477 6.84454 98.5542 12.8902 98.5542H115.11C121.155 98.5542 126.056 93.6477 126.056 87.5952V13.4047C126.056 7.35227 121.155 2.4458 115.11 2.4458Z",
    stroke: "#B8B5DD",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1441_172268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 100,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSharedUsers);
export default __webpack_public_path__ + "static/media/no-shared-users.5f3997c9b02289f1259845890c7b9be6.svg";
export { ForwardRef as ReactComponent };